/**
 * Orb — the קוֹל (Voice) signature: ambient presence, NOT a mascot.
 * No face, no eyes. State is conveyed by color + motion AND a text label
 * (meaning never rides on motion/color alone — accessibility + the plan).
 * The breathing animation auto-disables under prefers-reduced-motion
 * (global rule in index.css).
 */

export type OrbState = 'idle' | 'listening' | 'thinking' | 'speaking' | 'attention' | 'offline';

const STATE_LABEL: Record<OrbState, string> = {
  idle: 'נוכחות הרכב',
  listening: 'מקשיב…',
  thinking: 'חושב…',
  speaking: 'מדבר',
  attention: 'יש משהו לשים לב אליו',
  offline: 'לא מחובר',
};

export function Orb({
  state = 'idle',
  size = 132,
  label,
  showLabel = false,
}: {
  state?: OrbState;
  size?: number;
  /** Visible caption under the orb. Falls back to the state label. */
  label?: string;
  showLabel?: boolean;
}) {
  const a11y = label ?? STATE_LABEL[state];
  return (
    <div className="flex flex-col items-center gap-3">
      <div className="kol-orb" data-state={state} style={{ width: size, height: size }} role="img" aria-label={a11y} />
      {showLabel && <div className="text-[15px] font-medium text-kol-ink-faint">{label ?? STATE_LABEL[state]}</div>}
    </div>
  );
}
